<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧" icon="format-list-bulleted">
			<b-button slot="button" type="is-info" :loading="isExportLoading" @click="onExportButtonClick">CSV出力</b-button>

			<search-bar slot="toolbar" @search="onSearchClick">
				<div class="search-wrap horizontal-center" slot>
					<div class="row">
						<div class="search-type">
							<div class="search-title">贈呈者</div>
							<b-select v-model="presentStaffId">
								<option value="">未選択</option>
								<option v-for="row in presentStaffs" :key="row.id" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>

						<div class="search-type">
							<div class="search-title">獲得者</div>
							<b-select v-model="recieveStaffId">
								<option value="">未選択</option>
								<option v-for="row in recieveStaffs" :key="row.id" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>

						<div class="search-type">
							<div class="search-title">獲得チーム</div>
							<b-select v-model="recieveTeamId">
								<option value="">未選択</option>
								<option v-for="row in recieveTeams" :key="row.id" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>
					</div>

					<div class="row">
						<div class="search-type">
							<div class="search-title">コイン</div>
							<b-select v-model="coinId">
								<option value="">未選択</option>
								<option v-for="row in coins" :key="row.id" :value="row.id">
									{{ row.name }}
								</option>
							</b-select>
						</div>

						<div class="search-type">
							<div class="search-title">期間指定</div>
							<date-picker :dateProvided="from"  @input="onFromInput"></date-picker>
							<div class="ml-10 mr-10">～</div>
							<date-picker :dateProvided="to"  @input="onToInput"></date-picker>
						</div>
					</div>
				</div>
			</search-bar>

			<b-table
				:loading="isLoading"
				:paginated="true"
				:per-page="$consts.TABLE_PER_PAGE"
				:striped="true"
				:hoverable="true"
				:data="list"
				@page-change="onPageChange"
				>

				<template slot-scope="props">
					<b-table-column label="日付" field="created" sortable>
						{{ props.row.created }}
					</b-table-column>
					<b-table-column label="贈呈" field="present" sortable>
						{{ props.row.present }}
					</b-table-column>
					<b-table-column label="獲得" field="recieve" sortable>
						{{ props.row.recieve }}
					</b-table-column>
					<b-table-column label="コイン" field="coin_name" sortable>
						{{ props.row.coin_name }}
					</b-table-column>
					<b-table-column label="いいね！" field="like_count" sortable number>
						{{ props.row.like_count }}
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-warning" type="button" @click="$router.push({ name: 'present-edit', params: { presentCoinId: props.row.id }})">編集</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>

				<section class="page-info" slot="bottom-left">
					<page-info :current="currentPage" :data="list"></page-info>
				</section>
			</b-table>
		</card-component>
	</div>

</template>

<script>
import qs from 'qs';
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'PresentList',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			currentPage: 1,
			isExportLoading: false,
			presentStaffId: '',
			recieveStaffId: '',
			recieveTeamId: '',
			coinId: '',
			from: '',
			to: '',
			coins: [],
			presentStaffs: [],
			recieveStaffs: [],
			recieveTeams: [],
		}
	},
	computed: {
		titleStack () {
			return [
				'贈呈一覧'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onFromInput: function(date) {
			this.from = date;
		},
		onToInput: function(date) {
			this.to = date;
		},
		onExportButtonClick: async function() {
			this.isExportLoading = true;

			let ep = 'present-coins/export?' + this.createGetParam();
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				this.isExportLoading = false;
			}
		},
		downloadCSV: function(data) {
			let fileName = `export_present.csv`;
			this.$utils.downloadCSV(data, fileName, true);
		},
		onSearchClick: function() {
			this.getData();
		},
		init: function() {
			this.getData();
		},
		createGetParam: function() {
			let data = {
				"from_staff_id": this.presentStaffId,
				"to_staff_id": this.recieveStaffId,
				"to_team_id": this.recieveTeamId,
				"coin_id": this.coinId,
				"from": this.from,
				"to": this.to,
			};

			return qs.stringify(data);
		},
		getData: async function() {
			this.isLoading = true;

			let ep = 'present-coins?' + this.createGetParam();
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
				this.coins = res.data.coins;
				this.presentStaffs = res.data.staffs;
				this.recieveStaffs = res.data.staffs;
				this.recieveTeams = res.data.teams;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>

<style lang="scss" scoped>
.searchbar {
}

.search-wrap {
	flex-wrap: wrap;

	.row {
		display: flex;
		align-items: center;
		margin: 10px 0;

		.search-title {
			margin-right: 10px;
		}
		.search-type {
			display: flex;
			align-items: center;
			margin-right: 30px;
		}
	}
}

</style>
